import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  id: string;
};

export const useVehicleMarkDelete = () => {
  const [vehicleMarkDeleteLoading, setVehicleMarkDeleteLoading] =
    useState(false);

  const vehicleMarkDeleteReq = useCallback(async (params: TParams) => {
    const { id } = params;
    setVehicleMarkDeleteLoading(true);
    const res = await request({
      path: "vehicle-popular/delete",
      method: "POST",
      body: JSON.stringify({
        vehicle_id: id.toString(),
      }),
    });
    setVehicleMarkDeleteLoading(false);
    return res?.data;
  }, []);

  return { vehicleMarkDeleteLoading, vehicleMarkDeleteReq };
};
